import { createWebHistory, createRouter } from "vue-router";

import HomePageCreativa360 from "../components/Pages/HomePageCreativa360";
import HomePageAboutUs from "../components/Pages/HomeAboutUs";
import HomePagePremiumServices from "../components/Pages/HomePremiumServices.vue";

const routes = [
  { path: "/", name: "HomePageCreativa360", component: HomePageCreativa360 },
  { path: "/sobrenosotros", name: "HomePageAboutUs", component: HomePageAboutUs },
  { path: "/premium", name: "HomePagePremiumServices", component: HomePagePremiumServices }, 

];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

export default router;
